/* eslint-disable max-lines */
import { SelectionGroupOption } from 'common/components';

const CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/new-kitchen';

export type CategoryStructure = {
  name: string;
  image: string;
  href: string;
};

export enum CategoriesTabName {
  BuiltInAppliances = '1',
  FreestandingAppliances = '2',
  Countertops = '3',
  WallPanels = '4',
  SinksAndFaucets = '5',
  WaterFilters = '6',
  TablesAndChairs = '7',
  KitchenAccessories = '8',
}

export const CATEGORIES_TAB_LIST: SelectionGroupOption[] = [
  {
    text: 'Встраиваемая техника',
    value: CategoriesTabName.BuiltInAppliances,
  },
  {
    text: 'Отдельностоящая техника',
    value: CategoriesTabName.FreestandingAppliances,
  },
  {
    text: 'Столешницы',
    value: CategoriesTabName.Countertops,
  },
  {
    text: 'Стеновые панели',
    value: CategoriesTabName.WallPanels,
  },
  {
    text: 'Мойки и смесители',
    value: CategoriesTabName.SinksAndFaucets,
  },
  {
    text: 'Фильтры для воды',
    value: CategoriesTabName.WaterFilters,
  },
  {
    text: 'Столы и стулья',
    value: CategoriesTabName.TablesAndChairs,
  },
  {
    text: 'Кухонные аксессуары',
    value: CategoriesTabName.KitchenAccessories,
  },
];

export const NEW_KITCHEN_CATEGORIES_BUILT_IN_APPLIANCES: CategoryStructure[] = [
  {
    name: 'Встраиваемые духовки',
    image: `${CDN_PATH}/categories/built-in-appliances/1.png/1.png`,
    href: '/catalogue/vstraivaemye-duhovki/',
  },
  {
    name: 'Встраиваемые варочные панели',
    image: `${CDN_PATH}/categories/built-in-appliances/2.png/2.png`,
    href: '/catalogue/vstraivaemye-varochnye-paneli/',
  },
  {
    name: 'Встраиваемые холодильники',
    image: `${CDN_PATH}/categories/built-in-appliances/3.png/3.png`,
    href: '/catalogue/vstraivaemye-holodilniki/',
  },
  {
    name: 'Встраиваемые вытяжки',
    image: `${CDN_PATH}/categories/built-in-appliances/4.png/4.png`,
    href: '/catalogue/vstraivaemye-vytyazhki/',
  },
  {
    name: 'Встраиваемые микроволновые печи',
    image: `${CDN_PATH}/categories/built-in-appliances/5.png/5.png`,
    href: '/catalogue/vstraivaemye-mikrovolnovye-pechi/',
  },
  {
    name: 'Встраиваемые посудомоечные машины',
    image: `${CDN_PATH}/categories/built-in-appliances/6.png/6.png`,
    href: '/catalogue/vstraivaemye-posudomoechnye-mashiny/',
  },
  {
    name: 'Встраиваемые морозильные камер',
    image: `${CDN_PATH}/categories/built-in-appliances/7.png/7.png`,
    href: '/catalogue/vstraivaemye-morozilnye-kamery/',
  },
  {
    name: 'Встраиваемые стиральные машины',
    image: `${CDN_PATH}/categories/built-in-appliances/8.png/8.png`,
    href: '/catalogue/vstraivaemye-stiralnye-mashiny/',
  },
  {
    name: 'Встраиваемые кофемашины',
    image: `${CDN_PATH}/categories/built-in-appliances/9.png/9.png`,
    href: '/catalogue/vstraivaemye-kofemashiny/',
  },
  {
    name: 'Встраиваемые винные шкафы',
    image: `${CDN_PATH}/categories/built-in-appliances/10.png/10.png`,
    href: '/catalogue/vstraivaemye-vinnye-shkafy/',
  },
];

export const NEW_KITCHEN_CATEGORIES_FREESTANDING_APPLIANCES: CategoryStructure[] = [
  {
    name: 'Варочные панели',
    image: `${CDN_PATH}/categories/freestanding-appliances/1.png/1.png`,
    href: '/catalogue/varochnye-paneli/',
  },
  {
    name: 'Духовые шкафы',
    image: `${CDN_PATH}/categories/freestanding-appliances/2.png/2.png`,
    href: '/catalogue/duhovye-shkafy/',
  },
  {
    name: 'Вытяжки для кухни',
    image: `${CDN_PATH}/categories/freestanding-appliances/3.png/3.png`,
    href: '/catalogue/vytyazhki-dlya-kuhni/',
  },
  {
    name: 'Холодильники',
    image: `${CDN_PATH}/categories/freestanding-appliances/4.png/4.png`,
    href: '/catalogue/holodilniki/',
  },
  {
    name: 'Микроволновые печи',
    image: `${CDN_PATH}/categories/freestanding-appliances/5.png/5.png`,
    href: '/catalogue/mikrovolnovye-pechi/',
  },
  {
    name: 'Кухонные плиты',
    image: `${CDN_PATH}/categories/freestanding-appliances/6.png/6.png`,
    href: '/catalogue/kuhonnye-plity/',
  },
  {
    name: 'Посудомоечные машины',
    image: `${CDN_PATH}/categories/freestanding-appliances/7.png/7.png`,
    href: '/catalogue/posudomoechnye-mashiny/',
  },
  {
    name: 'Морозильные камеры',
    image: `${CDN_PATH}/categories/freestanding-appliances/8.png/8.png`,
    href: '/catalogue/morozilnye-kamery/',
  },
  {
    name: 'Мини печи',
    image: `${CDN_PATH}/categories/freestanding-appliances/9.png/9.png`,
    href: '/catalogue/mini-pechi/',
  },
  {
    name: 'Винные шкафы',
    image: `${CDN_PATH}/categories/freestanding-appliances/10.png/10.png`,
    href: '/catalogue/vinnye-shkafy/',
  },
];

export const NEW_KITCHEN_CATEGORIES_COUNTERTOPS: CategoryStructure[] = [
  {
    name: 'Столешницы для кухни',
    image: `${CDN_PATH}/categories/countertops/1.png/1.png`,
    href: '/catalogue/stoleshnicy/',
  },
  {
    name: 'Планки и комплекты для установки столешниц',
    image: `${CDN_PATH}/categories/countertops/2.png/2.png`,
    href: '/catalogue/planki-i-komplekty-dlya-ustanovki-stoleshnic/',
  },
  {
    name: 'Кромочный пластик для кухонных столешниц',
    image: `${CDN_PATH}/categories/countertops/3.png/3.png`,
    href: '/catalogue/kromochnyy-plastik-dlya-kuhonnyh-stoleshnic/',
  },
  {
    name: 'Плинтусы для кухонных столешниц',
    image: `${CDN_PATH}/categories/countertops/4.png/4.png`,
    href: '/catalogue/plintusy-dlya-kuhonnyh-stoleshnic/',
  },
  {
    name: 'Заглушки для кухонных плинтусов',
    image: `${CDN_PATH}/categories/countertops/5.png/5.png`,
    href: '/catalogue/zaglushki-dlya-kuhonnyh-plintusov/',
  },
];

export const NEW_KITCHEN_CATEGORIES_WALL_PANELS: CategoryStructure[] = [
  {
    name: 'Стеновые панели для кухни',
    image: `${CDN_PATH}/categories/wall-panels/1.png/1.png`,
    href: '/catalogue/stenovye-paneli-dlya-kuhni/',
  },
  {
    name: 'Планки для стеновых кухонных панелей',
    image: `${CDN_PATH}/categories/wall-panels/2.png/2.png`,
    href: '/catalogue/planki-dlya-stenovyh-kuhonnyh-paneley/',
  },
];

export const NEW_KITCHEN_CATEGORIES_SINKS_AND_FAUCETS: CategoryStructure[] = [
  {
    name: 'Кухонные мойки',
    image: `${CDN_PATH}/categories/sinks-and-faucets/1.png/1.png`,
    href: '/catalogue/kuhonnye-moyki/',
  },
  {
    name: 'Кухонные смесители',
    image: `${CDN_PATH}/categories/sinks-and-faucets/2.png/2.png`,
    href: '/catalogue/kuhonnye-smesiteli/',
  },
  {
    name: 'Измельчители пищевых отходов',
    image: `${CDN_PATH}/categories/sinks-and-faucets/3.png/3.png`,
    href: '/catalogue/izmelchiteli-pishchevyh-othodov/',
  },
  {
    name: 'Комплектующие для установки моек',
    image: `${CDN_PATH}/categories/sinks-and-faucets/4.png/4.png`,
    href: '/catalogue/komplektuyushchie-dlya-ustanovki-moek/',
  },
  {
    name: 'Гигиенические поддоны под мойку',
    image: `${CDN_PATH}/categories/sinks-and-faucets/5.png/5.png`,
    href: '/catalogue/gigienicheskie-poddony-pod-moyku/',
  },
  {
    name: 'Дозаторы для жидкого мыла и органайзеры для мойки',
    image: `${CDN_PATH}/categories/sinks-and-faucets/6.png/6.png`,
    href: '/catalogue/dozatory-dlya-zhidkogo-myla-i-organayzery-dlya-moyki/',
  },
  {
    name: 'Аксессуары для кухонных моек',
    image: `${CDN_PATH}/categories/sinks-and-faucets/7.png/7.png`,
    href: '/catalogue/aksessuary-dlya-moyki/',
  },
];

export const NEW_KITCHEN_CATEGORIES_WATER_FILTERS: CategoryStructure[] = [
  {
    name: 'Фильтры для воды под мойку',
    image: `${CDN_PATH}/categories/water-filters/1.png/1.png`,
    href: '/catalogue/filtry-dlya-vody-pod-moyku/',
  },
  {
    name: 'Системы обратного осмоса',
    image: `${CDN_PATH}/categories/water-filters/2.png/2.png`,
    href: '/catalogue/sistemy-obratnogo-osmosa/',
  },
  {
    name: 'Фильтры-кувшины',
    image: `${CDN_PATH}/categories/water-filters/3.png/3.png`,
    href: '/catalogue/filtry-kuvshiny/',
  },
  {
    name: 'Картриджи для воды',
    image: `${CDN_PATH}/categories/water-filters/4.png/4.png`,
    href: '/catalogue/kartridzhi-dlya-vody/',
  },
  {
    name: 'Комплекты картриджей для воды',
    image: `${CDN_PATH}/categories/water-filters/5.png/5.png`,
    href: '/catalogue/komplekty-kartridzhey-dlya-vody/',
  },
  {
    name: 'Мембраны обратного осмоса',
    image: `${CDN_PATH}/categories/water-filters/6.png/6.png`,
    href: '/catalogue/membrany-obratnogo-osmosa/',
  },
  {
    name: 'Кассеты для фильтров-кувшинов',
    image: `${CDN_PATH}/categories/water-filters/7.png/7.png`,
    href: '/catalogue/kassety-dlya-filtrov-kuvshinov/',
  },
  {
    name: 'Краны чистой воды',
    image: `${CDN_PATH}/categories/water-filters/8.png/8.png`,
    href: '/catalogue/krany-chistoy-vody/',
  },
  {
    name: 'Запасные части для фильтров воды',
    image: `${CDN_PATH}/categories/water-filters/9.png/9.png`,
    href: '/catalogue/zapasnye-chasti-dlya-filtrov-vody/',
  },
  {
    name: 'Пурифайеры',
    image: `${CDN_PATH}/categories/water-filters/10.png/10.png`,
    href: '/catalogue/purifayery/',
  },
  {
    name: 'Фильтры-насадки на краны',
    image: `${CDN_PATH}/categories/water-filters/11.png/11.png`,
    href: '/catalogue/filtry-nasadki-na-krany/',
  },
];

export const NEW_KITCHEN_CATEGORIES_TABLES_AND_CHAIRS: CategoryStructure[] = [
  {
    name: 'Кухонные столы',
    image: `${CDN_PATH}/categories/tables-and-chairs/1.png/1.png`,
    href: '/catalogue/kuhonnye-stoly/',
  },
  {
    name: 'Стулья для кухни',
    image: `${CDN_PATH}/categories/tables-and-chairs/2.png/2.png`,
    href: '/catalogue/stulya-dlya-kuhni/',
  },
  {
    name: 'Табуреты',
    image: `${CDN_PATH}/categories/tables-and-chairs/3.png/3.png`,
    href: '/catalogue/taburety/',
  },
  {
    name: 'Кухонные диваны',
    image: `${CDN_PATH}/categories/tables-and-chairs/4.png/4.png`,
    href: '/catalogue/kuhonnye-divany/',
  },
  {
    name: 'Барные стулья для кухни',
    image: `${CDN_PATH}/categories/tables-and-chairs/5.png/5.png`,
    href: '/catalogue/barnye-stulya-dlya-kuhni/',
  },
  {
    name: 'Кухонные уголки',
    image: `${CDN_PATH}/categories/tables-and-chairs/6.png/6.png`,
    href: '/catalogue/kuhonnye-ugolki/',
  },
  {
    name: 'Комплектующие для столов и стульев',
    image: `${CDN_PATH}/categories/tables-and-chairs/7.png/7.png`,
    href: '/catalogue/komplektuyushchie-dlya-stolov-i-stulev/',
  },
];

export const NEW_KITCHEN_CATEGORIES_KITCHEN_ACCESSORIES: CategoryStructure[] = [
  {
    name: 'Разделочные доски',
    image: `${CDN_PATH}/categories/kitchen-accessories/1.png/1.png`,
    href: '/catalogue/razdelochnye-doski/',
  },
  {
    name: 'Ножи кухонные',
    image: `${CDN_PATH}/categories/kitchen-accessories/2.png/2.png`,
    href: '/catalogue/nozhi-kuhonnye/',
  },
  {
    name: 'Подставки и держатели для ножей',
    image: `${CDN_PATH}/categories/kitchen-accessories/3.png/3.png`,
    href: '/catalogue/podstavki-i-derzhateli-dlya-nozhey/',
  },
  {
    name: 'Точилки для ножей',
    image: `${CDN_PATH}/categories/kitchen-accessories/4.png/4.png`,
    href: '/catalogue/tochilki-dlya-nozhey/',
  },
  {
    name: 'Подставки под горячее, прихватки',
    image: `${CDN_PATH}/categories/kitchen-accessories/5.png/5.png`,
    href: '/catalogue/podstavki-pod-goryachee-prihvatki/',
  },
  {
    name: 'Крючки для полотенец',
    image: `${CDN_PATH}/categories/kitchen-accessories/6.png/6.png`,
    href: '/catalogue/kryuchki-dlya-polotenec/',
  },
  {
    name: 'Органайзеры для кухни',
    image: `${CDN_PATH}/categories/kitchen-accessories/7.png/7.png`,
    href: '/catalogue/organayzery-dlya-kuhni/',
  },
  {
    name: 'Универсальные коврики для кухни',
    image: `${CDN_PATH}/categories/kitchen-accessories/8.png/8.png`,
    href: '/catalogue/universalnye-kovriki-dlya-kuhni/',
  },
  {
    name: 'Салфетки сервировочные',
    image: `${CDN_PATH}/categories/kitchen-accessories/9.png/9.png`,
    href: '/catalogue/salfetki-servirovochnye/',
  },
  {
    name: 'Кухонные принадлежности',
    image: `${CDN_PATH}/categories/kitchen-accessories/10.png/10.png`,
    href: '/catalogue/kuhonnye-prinadlezhnosti/',
  },
  {
    name: 'Текстиль для кухни',
    image: `${CDN_PATH}/categories/kitchen-accessories/11.png/11.png`,
    href: '/catalogue/tekstil-dlya-kuhni/',
  },
  {
    name: 'Дуршлаги и сита',
    image: `${CDN_PATH}/categories/kitchen-accessories/12.png/12.png`,
    href: '/catalogue/durshlagi-i-sita/',
  },
  {
    name: 'Кондитерский инвентарь',
    image: `${CDN_PATH}/categories/kitchen-accessories/13.png/13.png`,
    href: '/catalogue/konditerskiy-inventar/',
  },
  {
    name: 'Мерные ёмкости',
    image: `${CDN_PATH}/categories/kitchen-accessories/14.png/14.png`,
    href: '/catalogue/mernye-emkosti/',
  },
  {
    name: 'Открывалки, консервные ножи',
    image: `${CDN_PATH}/categories/kitchen-accessories/15.png/15.png`,
    href: '/catalogue/otkryvalki-konservnye-nozhi/',
  },
  {
    name: 'Барный инвентарь',
    image: `${CDN_PATH}/categories/kitchen-accessories/16.png/16.png`,
    href: '/catalogue/barnyy-inventar/',
  },
  {
    name: 'Держатели для бумажных полотенец',
    image: `${CDN_PATH}/categories/kitchen-accessories/17.png/17.png`,
    href: '/catalogue/derzhateli-dlya-bumazhnyh-polotenec/',
  },
  {
    name: 'Ручные измельчители',
    image: `${CDN_PATH}/categories/kitchen-accessories/18.png/18.png`,
    href: '/catalogue/ruchnye-izmelchiteli/',
  },
];

export const CATEGORIES_MAP: Record<
  CategoriesTabName,
  CategoryStructure[]
> = {
  [CategoriesTabName.BuiltInAppliances]: NEW_KITCHEN_CATEGORIES_BUILT_IN_APPLIANCES,
  [CategoriesTabName.FreestandingAppliances]: NEW_KITCHEN_CATEGORIES_FREESTANDING_APPLIANCES,
  [CategoriesTabName.Countertops]: NEW_KITCHEN_CATEGORIES_COUNTERTOPS,
  [CategoriesTabName.WallPanels]: NEW_KITCHEN_CATEGORIES_WALL_PANELS,
  [CategoriesTabName.SinksAndFaucets]: NEW_KITCHEN_CATEGORIES_SINKS_AND_FAUCETS,
  [CategoriesTabName.WaterFilters]: NEW_KITCHEN_CATEGORIES_WATER_FILTERS,
  [CategoriesTabName.TablesAndChairs]: NEW_KITCHEN_CATEGORIES_TABLES_AND_CHAIRS,
  [CategoriesTabName.KitchenAccessories]: NEW_KITCHEN_CATEGORIES_KITCHEN_ACCESSORIES,
};
